/**
 * Format `updated_at` for the transfer list — Angular `date:'MM/dd/yyyy hh:mm a'`.
 * API may return ISO strings, `YYYY-MM-DD HH:mm:ss`, or Unix timestamps (seconds).
 */
export function formatTransferUpdatedAt(
  value: string | number | null | undefined,
): string {
  if (value == null || value === '') return ''

  let dateObj: Date
  if (typeof value === 'number') {
    dateObj =
      value.toString().length === 10 ? new Date(value * 1000) : new Date(value)
  } else if (/^\d+$/.test(value.trim())) {
    const n = Number(value)
    if (Number.isNaN(n)) return ''
    dateObj = value.trim().length === 10 ? new Date(n * 1000) : new Date(n)
  } else {
    dateObj = value.includes(' ') ? new Date(value.replace(' ', 'T')) : new Date(value)
  }

  if (!(dateObj instanceof Date) || Number.isNaN(dateObj.getTime())) return ''

  const month = String(dateObj.getMonth() + 1).padStart(2, '0')
  const day = String(dateObj.getDate()).padStart(2, '0')
  const year = String(dateObj.getFullYear())

  let hours = dateObj.getHours()
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  const ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12

  return `${month}/${day}/${year} ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`
}
